module.exports = __webpack_public_path__ + "img/opt-out-privacy-bg.webp";